// ══════════════════════════════════════════════════════════════
// LISTA DE AMIGOS (agregado 16/10/2026)
//
// Cada usuario tiene UN documento Amigos/{uid} con el array Lista
// (UIDs de sus amigos). Una sola lectura trae toda la lista, y
// arrayUnion/arrayRemove evitan pisar cambios hechos en otra pestaña.
//
// Es una lista personal (como contactos): agregar a alguien no le pide
// confirmación a la otra persona. Solo cada uno lee y edita la suya.
// Reglas: ver claude/firestore.rules.chat.txt.
// ══════════════════════════════════════════════════════════════

import { arrayRemove, arrayUnion, doc, setDoc } from "firebase/firestore";
import { db } from "./firebase-config";

export const MAX_FRIENDS = 200;

export async function AddFriend(myUid: string, friendUid: string) {
  if (!myUid || !friendUid || myUid === friendUid) return;
  // setDoc con merge crea el documento la primera vez.
  await setDoc(
    doc(db, "Amigos", myUid),
    { Lista: arrayUnion(friendUid) },
    { merge: true },
  );
}

export async function RemoveFriend(myUid: string, friendUid: string) {
  if (!myUid || !friendUid) return;
  await setDoc(
    doc(db, "Amigos", myUid),
    { Lista: arrayRemove(friendUid) },
    { merge: true },
  );
}
